<template>
    <div class="pagination">
        <div
            class="pagination__arrow"
            :class="{ '--disabled': !prevPage }"
            @click="prevPage && setPagination(prevPage)"
        >
            <a-icon icon="ArrowLeft" height="24px" />
        </div>

        <div class="pagination__input">
            <input
                class="form-control form-control-xs text-center mb-0"
                :value="pagination.page"
                :custom-class="'text-center'"
                :placeholder="pagination.page"
                type="number"
                min="1"
                @change="setPagination($event.target.value)"
            />
        </div>

        z

        <div
            v-text="pagination.totalPages"
            class="pagination__total cursor-pointer"
            @click="setPagination(pagination.totalPages)"
        />

        <div
            class="pagination__arrow"
            :class="{ '--disabled': !nextPage }"
            @click="nextPage && setPagination(nextPage)"
        >
            <a-icon icon="ArrowRight" height="24px" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThePagination',
    props: {
        pagination: {
            type: Object,
            required: true,
            validator: (value) => {
                const requiredFields = [
                    'nextPage', 'page', 'perPage', 'totalPages'
                ]
                return requiredFields.every(field =>
                    Object.prototype.hasOwnProperty.call(value, field)
                )
            }
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        prevPage() {
            return this.pagination.prevPage
        },
        nextPage() {
            return this.pagination.nextPage
        }
    },
    methods: {
        setPagination(page) {
            if (this.isLoading) {
                return
            }

            if (+page > +this.pagination.totalPages) {
                page = this.pagination.totalPages
            }

            if (+page < 1) {
                page = 1
            }

            this.$emit('change', page)
        }
    }
}
</script>
